import React from 'react';
import { ArrowLeftRight, Flag, Shield, Zap } from 'lucide-react';
import {
  STUDIO_COPY,
  STUDIO_SELECTION_CLAIMS_ENABLED,
} from '../config';

/**
 * lucide-react@0.263.1 has no ShieldHalf export. Primary set otherwise:
 * Flag / Zap / ArrowLeftRight / Shield (not Volleyball, not RefreshCw).
 */
const PLAY_TYPES = [
  { key: 'td', Icon: Flag, label: STUDIO_COPY.expectationTouchdowns },
  { key: 'explosive', Icon: Zap, label: STUDIO_COPY.expectationExplosives },
  { key: 'turnover', Icon: ArrowLeftRight, label: STUDIO_COPY.expectationTurnovers },
  { key: 'stop', Icon: Shield, label: STUDIO_COPY.expectationStops },
] as const;

type StudioExpectationPanelProps = {
  className?: string;
};

/**
 * Moat lives here — at the moment a user decides to spend a reel.
 * Positive selection + chrono always ship. Exclusion copy is held behind
 * STUDIO_SELECTION_CLAIMS_ENABLED until dropped_by_playtype confirms on v1.
 */
const StudioExpectationPanel: React.FC<StudioExpectationPanelProps> = ({
  className,
}) => {
  return (
    <aside
      className={`studio-expectation ${className ?? ''}`.trim()}
      data-testid="studio-vod-expectation"
    >
      <p className="studio-expectation-headline">
        {STUDIO_COPY.expectationHeadline}
      </p>
      <ul className="studio-expectation-list">
        {PLAY_TYPES.map((row) => {
          const Icon = row.Icon;
          return (
            <li key={row.key}>
              <span className="studio-expectation-icon" aria-hidden="true">
                <Icon size={20} strokeWidth={1.75} />
              </span>
              <span>{row.label}</span>
            </li>
          );
        })}
      </ul>
      {STUDIO_SELECTION_CLAIMS_ENABLED ? (
        <p
          className="studio-expectation-out"
          data-testid="studio-vod-expectation-out"
        >
          {STUDIO_COPY.expectationLeftOut}
        </p>
      ) : null}
      <p className="studio-expectation-chrono">{STUDIO_COPY.expectationChrono}</p>
    </aside>
  );
};

export default StudioExpectationPanel;
